import './MobileMenu.css';
import PageEndBlank from '../../components/PageContainer/PageEndBlank';

const MobileMenu = () => {
	return (
		<div id="mobile-menu">
			<div><a href="/">About Us</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/officers">Meet the Team</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/join">Join the Society</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/history">Our History</a></div>
			<div><a href="/events">Events</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/upcoming_events">Upcoming Events</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/previous_events">Previous Events</a></div>
			<div><a href="/tools">Tools</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/bulletins">Bulletin Viewer</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/litcal">Liturgical Day</a></div>
			<div><a href="/prayer">Prayer</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/rosary">Rosary Companion</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/sorrows">Seven Sorrows</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/chaplet">Holy Name Chaplet</a></div>
				<div><img src="/static/icons/subdirectory.svg" width="20px" height="20px" alt="•" /><a href="/mercy">Divine Mercy Chaplet</a></div>
			{/* <div><a href="/members_only">Members</a></div> */}
			{/* <div><a href="/contact">Contact</a></div> */}
			<div id="mobile-menu-ending-blank"><PageEndBlank /></div>
		</div>
	);
};

export default MobileMenu;
